import dayjs from 'dayjs';

import { DATE_PATTERN_VALIDATION, NUMBER_OF_MONTHS_IN_YEAR } from '@/config/common.config';

// TODO:
// 1. Move everything to class DateUtils
// 2. Replace some methods to dayjs instead if it possible
// 3. getDateWithProperTimeOffset - check does it work properly, QA has checked it manually but I have doubts
// 4. !!!! Add tests since incorrect work of these methods can display incorrect data to the user
export function isValidDate(date: Date): boolean {
  return typeof date !== 'undefined' && dayjs(date).isValid();
}

export function getDateWithProperTimeOffset(date: Date): Date {
  if (!isValidDate(date)) {
    return date;
  }

  const minuteMilliseconds = 60_000;
  const timezoneOffsetMinutes = date.getTimezoneOffset();
  const directinalOffsetMinutes = timezoneOffsetMinutes > 0 ? -timezoneOffsetMinutes : timezoneOffsetMinutes;

  const newDate = new Date(date.getTime() - directinalOffsetMinutes * minuteMilliseconds);
  return timezoneOffsetMinutes < 0 ? newDate : new Date(newDate.setHours(0, 0, 0, 0));

}

export function datesAreEqual(
  firstDate: Date | null,
  secondDate: Date | null
): boolean {
  if (!firstDate || !secondDate) {
    return false;
  }

  return (
    firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()
  );
}

export function getTodaysDate(locale: string = 'en-GB') {
  return new Date(Date.now()).toLocaleDateString(locale);
}

export function getTomorrowsDate() {
  return dayjs(new Date()).add(1, 'day').format('DD/MM/YYYY');

}

export const checkIfManualDateCorrect = (date: string) => {
  return DATE_PATTERN_VALIDATION.test(date) &&
    Number(date.split('/')[1]) <= NUMBER_OF_MONTHS_IN_YEAR;
};

export function validateDateFormat(date: string, format: string) {
  return dayjs(date, format).format(format) === date;
}

export function convertDateToUTC(datePeriod: string) {
  const dateInUTCFormat = new Date(datePeriod).toUTCString();
  return new Date(dateInUTCFormat);
}

export function getDateWithZeroTimeZone(date: Date): Date {
  if (isValidDate(date)) {
    const offsetMinutes: number = date.getTimezoneOffset();
    date.setHours(0, offsetMinutes < 0 ? -offsetMinutes : offsetMinutes, 0, 0);
  }

  return date;
}

export function addDays(date: Date, days: number): Date {
  date.setDate(date.getDate() + days);
  return date;
}

/**
 * Converts a Date object or date string to a mutation-safe string format (YYYY-MM-DDT00:00:00).
 * This preserves the user's intended calendar day and sets time to midnight,
 * avoiding timezone-related issues that can occur with toISOString().
 * 
 * @param date - The Date object or string (YYYY-MM-DD or YYYY-MM-DDT...) to convert
 * @returns A string in the format "YYYY-MM-DDT00:00:00"
 */
export function toMutationDateString(date: Date | string): string {
  if (typeof date === 'string') {
    // Handle both 'YYYY-MM-DD' and 'YYYY-MM-DDT...' formats
    const [ymd] = date.split('T');
    const [year, month, day] = ymd.split('-');
    if (!year || !month || !day) {
      return `${ymd}T00:00:00`;
    }
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00`;
}
